import { Component, OnInit } from '@angular/core';
import { CmsService } from '../../cms.service';
import { AppService } from 'src/app/app.service';
import { Constants } from 'src/app/shared/utils/constants';
import { Permission } from 'src/app/models/permission.model';
import { ExportService } from 'src/app/shared/services/export.service';
import { getTimeRemoveTimezoneOffset } from 'src/app/shared/utils/helper';
import { ExportTraderRequest } from '../../models/trader.interface';

const DEFAULT_CONDITION = {
  filter: 'mt5_account',
  order: undefined,
  orderBy: undefined,
  keyword: '',
  from: undefined,
  to: undefined
}

@Component({
  selector: 'fx-trader-list',
  templateUrl: './trader-list.component.html',
  styleUrls: ['./trader-list.component.sass']
})
export class TraderListComponent implements OnInit {
  pageInfo = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  condition = {...DEFAULT_CONDITION};
  data = [];
  selectedItem = {};
  ibInfors: Record<string, string[]> = {};
  selectedIbInfor = [];
  searchTypes =
  [
    {
      value:'mt5_account',
      name:"MT5 Account"
    },
    {
      value:'name',
      name:"Username"
    },
    {
      value:'email',
      name:"Email"
    }
  ]
  sort: any = {
    mt5_account: 'desc',
    username: 'desc',
    email: 'desc'
  };
  isShowAccountBlance: boolean = false;
  permission: Permission;
  showError: boolean = false;
  constructor(
    private service: CmsService,
    private appService: AppService,
    private exportService: ExportService
  ) { 
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
    this.getTraders();
  }

  getIbInfoById(userId): void {
    this.selectedIbInfor = [];
    if (this.ibInfors?.[userId]?.length) {
      this.selectedIbInfor = this.ibInfors[userId];
    } else {
      this.service.getIBInfotByUser(userId, true)
        .subscribe(res => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.ibInfors[userId] = res.data;
            this.selectedIbInfor = res.data;
          }
        });
    }
  }

  getTraders() {
    const params = {
      keyword: (this.condition.keyword)
      ? encodeURIComponent((this.condition.keyword).trim())
      : this.condition.keyword,
      search_by: this.condition.filter,
      order_type: this.condition.order,
      order_by: this.getOrder(),
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getTraders(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }

  search(event: any): void {
    if (event === 'click' || event.keyCode === 13) {
      this.pageInfo.pageIndex = 1;
      this.getTraders();
    }
  }

  onViewBlance(item) {
    this.selectedItem = item;
    this.isShowAccountBlance = true;
  }

  onExport() {
    if(this.condition.from && !this.condition.to || this.condition.to && !this.condition.from || this.condition.to < this.condition.from) {
      this.showError = true;
      return
    }
    this.showError = false;
    const params: ExportTraderRequest = {
      page: 1,
      page_size: Number.MAX_SAFE_INTEGER,
    };
    if(this.condition.from && this.condition.to){
      params.from = getTimeRemoveTimezoneOffset(this.condition.from);
      params.to = getTimeRemoveTimezoneOffset(this.condition.to);
    }
    this.service.exportTraders(params).subscribe();
  }

  getOrder(): string {
    switch (this.condition.orderBy) {
      case 'mt5_account':
        return `mt5_account`;
      case 'email':
        return `email`;
      case 'username':
        return `first_name`;
      default:
        return `mt5_account`;
    }
  }

  onRefresh() {
    this.ibInfors = {};
    this.condition = {...DEFAULT_CONDITION};
    this.showError = false;
    this.pageInfo.pageIndex = 1;
    this.sort = {
      mt5_account: 'desc',
      username: 'desc',
      email: 'desc'
    };
    const params = {
      keyword: (this.condition.keyword)
      ? encodeURIComponent((this.condition.keyword).trim())
      : this.condition.keyword,
      search_by: this.condition.filter,
      order_type: this.condition.order,
      order_by: this.getOrder(),
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getTraders(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }

  sorting(column: string): void {
    // tslint:disable-next-line:no-unused-expression
    this.sort[column] = this.sort[column] === 'desc' ? 'asc' : 'desc';
    this.condition.orderBy = column;
    this.condition.order = this.sort[column];
    this.getTraders();
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getTraders();
  }

}
